<template>
	<div>
		<ag-grid-vue class="ag-theme-balham"
		    style="height: 100% !important;"
			:column-defs="cols"
			:row-data="rows"
			:pagination="pagination"
			:paginationPageSize="paginationPageSize"
			@grid-ready="onGridReady"
		/>
	</div>
</template>

<style scoped>
.ag-layout-normal {
    height: 100% !important; 
	align-items: center;
}
</style>


<script>
	import {AgGridVue} from 'ag-grid-vue';

	export default {
		props: {
			cols: {
				type: Array,
				required: true,
			},

			rows: {
				type: Array,
				required: true,
			},

			pagination: {
				type: Boolean,
				required: false,
				default: false,
			},

			paginationPageSize: {
				type: Number,
				required: false,
				default: 20,
			}
		},

		data() {
			return {
				gridApi: null,
			};
		},

		components: {
			'ag-grid-vue': AgGridVue,
		},

		methods: {
			onGridReady(params) {
				this.gridApi = params.api;
				this.fitColumns();
			},

			fitColumns() {
				this.gridApi.sizeColumnsToFit();
			},
		},

		created() {
			window.addEventListener('resize', this.fitColumns);
		},

		destroyed() {
			window.removeEventListener('resize', this.fitColumns);
		},
	};
</script>
